// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Path23Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 83 43"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M73.02 0v16.674h-.108c-2.189-2.428-4.923-3.271-8.096-3.271-6.499 0-11.394 4.263-13.113 9.9-1.96-6.21-7.014-10.017-14.508-10.017-6.086 0-10.892 2.637-13.4 6.933v-5.34h-12.58V9.082h13.728V0H0v40.744h11.214V23.617h11.178a15.7 15.7 0 00-.511 4.026c0 8.5 6.728 14.463 15.314 14.463 7.22 0 11.978-3.272 14.495-9.236h-9.61c-1.3 1.792-2.286 2.324-4.885 2.324-3.014 0-5.612-2.537-5.612-5.545h19.569c.848 6.75 6.297 12.572 13.775 12.572 3.226 0 6.179-1.53 7.985-4.116h.109v2.637h9.885V0h-9.885zM31.896 23.738c.624-2.587 2.704-4.279 5.3-4.279 2.858 0 4.832 1.64 5.351 4.28h-10.65zM67.022 34.54c-3.644 0-5.909-3.277-5.909-6.698 0-3.657 1.97-7.174 5.909-7.174 4.084 0 5.71 3.517 5.71 7.174 0 3.468-1.724 6.698-5.71 6.698z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Path23Icon
/* prettier-ignore-end */
